<fieldset>
    <label id="committeeDateLabel" class="form-label">
        {{ 'components.application-detail-dashboard.application-status-detail.prefix' | translate }}
    </label>
    <si-select
        labelledby="committeeDateLabel"
        [options]="options()"
        [disabled]="control.disabled"
        class="form-control"
        [value]="control.value"
        [class.is-invalid]="control.invalid && (control.dirty || control.touched)"
        (valueChange)="control.setValue($event)"
    >
        <ng-template let-option siSelectOptionTemplate>{{ option.label }}</ng-template>

        @if (isMeetingsLoading() || hasMeetingsNextPage()) {
            <ng-template siSelectActions>
                @if (isMeetingsLoading()) {
                    <div class="flex justify-center w-full">
                        <si-loading-spinner class="[--loading-spinner-size:32px]" />
                    </div>
                } @else if (hasMeetingsNextPage()) {
                    <button
                        siSelectAction
                        type="button"
                        class="btn btn-link"
                        aria-label="load more"
                        (click)="loadMoreMeetings.emit()"
                    >
                        {{
                            'components.application-detail-dashboard.application-status-detail.load-more-dates'
                                | translate
                        }}
                    </button>
                }
            </ng-template>
        }
    </si-select>
    @if (control.invalid && control.touched) {
        <div class="mt-2 text-sm text-danger">
            {{ 'application-form.required' | translate }}
        </div>
    }
</fieldset>
